import { FC } from 'react';
import { Dialog } from 'primereact/dialog';

import { Button } from '@/components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { deleteSettlementByOID } from '@/services/deletedMySettlement';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

type ModalDeletedProps = {
  oids: number[];
  visible: boolean;
  onClose: (visible: boolean) => void;
};

const ModalDeleted: FC<ModalDeletedProps> = ({ oids, visible, onClose }) => {
  const { t } = useTranslation('mySettlement');

  const { mutate: deleteSettlement, isPending } = useMutation({
    mutationFn: deleteSettlementByOID,
    onSuccess: () => {
      onClose(true);
    },
  });

  const toggleDialog = () => {
    onClose(!visible);
  };

  const dialogHeader = (
    <div>
      <FontAwesomeIcon icon={faTrash} style={{ marginRight: '0.5rem' }} />
      {t('deleteSettlement')}
    </div>
  );

  const onDeleteButtonClick = () => {
    deleteSettlement({ oidLiquidacion: oids });
  };

  const footerContent = (
    <div className="w-full flex justify-content-end ">
      <Button
        label={t('cancel')}
        link
        onClick={toggleDialog}
        disabled={isPending}
        style={{ color: '#170a33', width: '100px' }}
      />
      <Button
        style={{ backgroundColor: '#FF0000', color: '#FFFFFF', width: '100px' }}
        label={t('delete')}
        onClick={onDeleteButtonClick}
        loading={isPending}
      />
    </div>
  );

  return (
    <Dialog
      header={dialogHeader}
      visible={visible}
      breakpoints={{ '1200px': '95vw' }}
      onHide={toggleDialog}
      footer={footerContent}
    >
      <div className="px-6 pb-6">
        <p>{t('deleteSettlementMessage')}</p>
      </div>
    </Dialog>
  );
};

export default ModalDeleted;
